import { Text, View, StyleSheet } from "@react-pdf/renderer";
import { formatNumberAnglo as formatNumber } from "../../../services/mappings";
import TotalRow from "./TotalRow";

const styles = StyleSheet.create({
  cell: {
    border: "1pt solid #000",
    textAlign: "right",
    fontWeight: "bold",
    paddingVertical: 4,
    paddingHorizontal: 2,
    fontSize: 8,
    backgroundColor: "#f0f0f0",
  },
  AmaTot: {
    width: "15%",
  },
  PaVmb: { width: "10%", fontSize: 7, paddingVertical: 6 },
  PaMr: { width: "10%", fontSize: 7, paddingVertical: 6 },
  PaTot: { width: "6%", fontSize: 7, paddingVertical: 6 },
  TaTot: { width: "13%", borderRight: "2pt solid #000" },
});

function ItemsSubTotal({ amaTot, paVmb, paMr, paTot, taTot }) {
  return (
    <View style={{ flexDirection: "row", marginVertical: 10 }}>
      <TotalRow title="SUBTOTAL PARTIDAS" value={""} />
      <View style={[styles.cell, styles.AmaTot]}>
        <Text>{formatNumber(amaTot, 2, 2)}</Text>
      </View>
      <View style={[styles.cell, styles.PaVmb]}>
        <Text>{formatNumber(paVmb, 2, 2)}</Text>
      </View>
      <View style={[styles.cell, styles.PaMr]}>
        <Text>{formatNumber(paMr, 2, 2)}</Text>
      </View>
      <View style={[styles.cell, styles.PaTot]}>
        <Text>{formatNumber(paTot, 2, 2)}</Text>
      </View>
      <View style={[styles.cell, styles.TaTot]}>
        <Text>{formatNumber(taTot, 2, 2)}</Text>
      </View>
    </View>
  );
}

export default ItemsSubTotal;
